import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useStore from 'store/AccountStore';
import RouterService from '../core/router.service';

// This component wraps the pages you want to protect
const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  // Get the state and the isHydrated flag from the store
  const { user, isHydrated } = useStore();

  // 1. While the store is rehydrating, show a loading indicator
  // This is the most important step for handling a refresh.
  if (!isHydrated) {
    return <div>Loading...</div>; // Or a spinner component
  }

  // 2. After hydration, if there is no user, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. If the user is logged in, but the URL is in their inaccessible list, redirect
  if (
    RouterService.isNotAccessibleForUser(
      location.pathname,
      user.schedulesMenuType
    )
  ) {
    // Redirect to a dashboard or a dedicated "access denied" page
    return <Navigate to="/access-denied" replace />;
  }

  // 4. If everything is fine, render the requested component
  return children;
};

export default ProtectedRoute;
